	<template>
		<div class="adminkeywordlist">
			<div class="pageTitle">关键词列表</div>
			<div class="page_box">
				<div class="keyword_box">
					<div style="padding: 0 15px;">
						<van-row style="border-bottom:1px solid #EEEEEE;color: #666666;">
							<van-col span="8">关键词</van-col>
							<van-col span="8">频次</van-col>
							<van-col span="8">7日环比</van-col>
						</van-row>
					</div>
					<div style="margin: 10px 0;">
						<van-row v-for="(item,index) in list" :key="'list_' + index" :class="index%2!=1?'hot_list_active':'hot_list'" @click="goInfo(item.key)">
							<van-col span="8">{{item.key}}</van-col>
							<van-col span="8">{{item.num}}</van-col>
							<van-col span="8" :class="item.sym=='-'?'green':'red'">{{item.proportion}}</van-col>
						</van-row>
					</div>
				</div>
			</div>
			
		</div>
	</template>
	<script>
		import admin from '../../api/admin';
		import { mapState } from 'vuex';
		import { Col, Row,Search,Cell } from 'vant';
		export default {
			data () {
				return {
					list:[],
				}
			},
			computed: {
				...mapState({
					user: state => state.param.user
				})
			},
			created () {
				this.getKeywordList()
			},
			methods: {
				getKeywordList(){
					admin.getKeywordList().then(res => {
						if(res.data.state==1){
							var list=res.data.data
							for(var i=0;i<list.length;i++){
								var proportion=list[i].proportion.toString()
								var sym=proportion.substring(0,1)
								list[i].sym=sym
							}
							this.list=list
						}
					})
				},
				goInfo(key){
					this.$router.push({name:'AdminBbsInfo',params:{key:key}});
				},
			},
			components: {
				[Col.name]: Col,
				[Row.name]: Row,
				[Search.name]:Search,
				[Cell.name]:Cell
			}
		}
	</script>
	<style lang="scss">
	.adminkeywordlist{
		.page_box{
			padding:15px;
		}
		.bbs_hot{
			border-top:10px solid #F8F8F8;
			.pageTitle{
				display: flex;
			}
		}
		.keyword_box{
			border: 1px solid #BBBBBB;
			border-radius: 4px;
			font-size:12px;
			.hot_list{
				background-color: #ffffff;color: #000000;
				padding:15px 30px;
			}
			.hot_list_active{
				background-color: #F8F8F8;color: #000000;
				padding:15px 30px;
			}
		}
		.van-row{
			padding:15px;
			color:#000000;
			align-items: center;
			display: flex;
			.van-col{
				text-align: center;
			}
			.green{
				color: #2B8600;
			}
			.red{
				color: #E02020;
			}
		}
	}
</style>
